import { useSelector } from "react-redux";

import type { TypedUseSelectorHook } from "react-redux";

import type { RootState } from "../../model/store";

/** `useSelector` pre-bound to the app's `RootState`. */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default useAppSelector;
